module.exports = __webpack_public_path__ + "static/media/photo-1431324155629-1a6deb1dec8d.0cb53fc0.jpeg";